export default "__VITE_ASSET__BHAPIM1h__"